jQuery(document).ready(function($) {
  const ANIMATE_TIME = 300;

  $('.tabs-nav li').first().addClass('current');

  $('.tabs-nav a').click(function() {

    // Check for active
    $('.tabs-nav li').removeClass('current');
    $(this).parent().addClass('current');

    // Display active tab
    let currentTab = $(this).attr('href');
    $('.tabs-content li').hide();
    $(currentTab).show();

    return false;
  });
});
